module.exports = __webpack_public_path__ + "static/media/logo.5eab6ca9.png";